import React from "react";

const VideoBarPersonMutedForMe = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 13.5472C5 12.3502 5.97033 11.3799 7.1673 11.3799H10.1086V17.6576H7.1673C5.97033 17.6576 5 16.6873 5 15.4903V13.5472Z"
        fill="white"
        className="filler"
      />
      <path
        d="M6.70312 14.5186L13.7275 7.91699V21.1202L6.70312 14.5186Z"
        fill="white"
        className="filler"
      />
      <path
        d="M16.9219 9.58691C20.3273 12.7022 20.3277 16.8558 16.9221 19.4518"
        stroke="white"
        strokeWidth="1.29559"
        className="stroker"
      />
      <path
        d="M20.3242 6C24.865 11.3809 24.8654 18.5554 20.3247 23.0394"
        stroke="white"
        strokeWidth="1.29559"
        className="stroker"
      />
      <path
        d="M23.6682 21.2635L7.34766 6.36328L5.99993 7.83948L22.3204 22.7397L23.6682 21.2635Z"
        fill="white"
        className="filler"
      />
    </svg>
  );
};

export default VideoBarPersonMutedForMe;
